import React from 'react'
import PropTypes from 'prop-types'
import CaseStudies from '../CaseStudies'
import Brands from '../Brands'
import Quote from '@components/_Service/Quote'
import BrandsSlider from '../BrandsSlider'
import Partners from '../Partners'
import PartnersGrid from '../PartnersGrid'
import SideBySide from '../SideBySide'
import Information from '../Information'

const Builder = ({ data, textColor, backgroundColor, caseStudies, slug, location }) => {
  return (
    <>
      {React.Children.toArray(
        data.map(block => {
          switch (block.__typename) {
            case 'ContentfulServiceCaseStudies':
              return (
                <>
                  {(caseStudies.length > 0) &&
                    <CaseStudies data={block} caseStudies={caseStudies} backgroundColor={backgroundColor} textColor={textColor}/>
                  }
                </>
              )

            case 'ContentfulServiceGallery':
              return (
                <>
                  {(block.itemsStyle === "Grid") ?
                    <Brands data={block} backgroundColor={backgroundColor} textColor={textColor}/>
                    :
                    <BrandsSlider data={block} backgroundColor={backgroundColor} textColor={textColor}/>
                  }
                </>
              )

            case 'ContentfulFeaturedInformation':
              return (
                <>
                  {(block.layout === "Information") ?
                    <Information data={block.featuredContent} title={block.featuredTitle}/>
                    :
                    <SideBySide data={block} bgColor={backgroundColor} tColor={textColor}/>
                  }
                </>
              )
            
            case 'ContentfulServicePartners':
              return (
                <>
                  {(block.itemsStyle === "Grid") ?
                    <PartnersGrid data={block} parentService={slug} backgroundColor={backgroundColor} textColor={textColor}/>
                  :
                    <Partners data={block} parentService={slug} backgroundColor={backgroundColor} textColor={textColor}/>
                  }
                </>
              )

            case 'ContentfulTestimonySlides':
              return (
                <Quote content={block.quotes}/>
              )

            default:
              return null
          }
        })
      )}
    </>
  )
}

Builder.propTypes = {
  data: PropTypes.array,
  textColour: PropTypes.string,
  backgroundColour: PropTypes.string,
}

export default Builder
